import { BREAKPOINTS } from '../config';
import { initSlider } from './splide-sett';
import {
  initScrollSplide,
  toggleAttrByMedia,
  initSplideSync,
} from './splide-tools';

const { mqTouch, mqTablet } = BREAKPOINTS;

const mq = window.matchMedia(`(max-width: ${mqTouch}px)`);

const thinkingSection = document.querySelector('.thinking');
const thinkingSplide = document.querySelector('.thinking__splide');
if (thinkingSection && thinkingSplide) {
  const splide = initSlider(thinkingSplide, {
    speed: 1300,
    gap: '4rem',
    direction: 'ttb',
    height: '16rem',
    drag: false,
    keyboard: false,

    breakpoints: {
      [mqTouch]: {
        gap: '2rem',
        height: '12rem',
        drag: true,
      },
    },
  });

  initScrollSplide(thinkingSection, splide);
  toggleAttrByMedia(thinkingSplide, mqTouch, 'data-lenis-prevent');
}

const industriesSection = document.querySelector('.industries');
const industriesSplide = document.querySelector('.industries__splide');
if (industriesSection && industriesSplide) {
  const splide = initSlider(industriesSplide, {
    perPage: 5,
    speed: 1300,
    focus: 1,

    gap: '0.5rem',
    direction: 'ttb',
    height: '29.5rem',
    drag: false,
    keyboard: false,

    breakpoints: {
      [mqTouch]: {
        type: 'loop',
        autoplay: true,
        perPage: 6,
        interval: 2000,

        gap: '1rem',
        height: '23rem',
        drag: true,
      },
    },
  });

  initScrollSplide(industriesSection, splide);
  initSplideSync(industriesSection, splide);
  toggleAttrByMedia(industriesSplide, mqTouch, 'data-lenis-prevent');
}

const relatedSplide = document.querySelector('.related__splide');
if (relatedSplide) {
  initSlider(relatedSplide, {
    perPage: 3,
    breakpoints: {
      [mqTouch]: {
        perPage: 2,
      },
      [mqTablet]: {
        perPage: 1,
      },
    },
  });
}

const embSplides = document.querySelectorAll('.emb-slider');
embSplides?.forEach(container => {
  const names = container.querySelectorAll('.emb-slider__name');

  initSlider(container, {
    type: 'fade',
    perPage: 1,
    rewind: true,
  });

  if (names.length) {
    const arrows = container.querySelector('.arrows');

    function updateArrowsMargin() {
      const maxHeight = Math.max(
        ...[...names].map(el => el.getBoundingClientRect().height)
      );
      if (arrows && maxHeight > 0) {
        arrows.style.minHeight = `${maxHeight}px`;
      }
    }

    requestAnimationFrame(updateArrowsMargin);
    const ro = new ResizeObserver(() => {
      requestAnimationFrame(updateArrowsMargin);
    });

    ro.observe(container);
  }
});

let workSliderInstance;
const work = document.querySelector('.work__splide');

const workInitSlider = () => {
  if (work && !workSliderInstance) {
    workSliderInstance = initSlider(work, {
      speed: 1300,
      perPage: 1,
    });
  }
};

const destroySliders = () => {
  // if (elemSliderInstances) {
  //   elemSliderInstances.forEach(instance => {
  //     instance.destroy();
  //   });
  //   elemSliderInstances = [];
  // }
  if (workSliderInstance) {
    workSliderInstance.destroy();
    workSliderInstance = null;
  }
};

const checkViewport = () => {
  // elemInitSliders();
  workInitSlider();

  if (!mq.matches) {
    destroySliders();
  }
};

mq.addEventListener('change', checkViewport);
document.addEventListener('DOMContentLoaded', checkViewport);
